import React from "react";
import { Box } from '@mui/joy';
import { Bar } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import ProposteAnalisiKPISet from "../proposteAnalisi/ProposteAnalisi.KPISet";

const ProposteTimeline = ({ dataProviderName, filters: defaultFilters, $key }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);
    const { filterModel } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const showKPI = true;
    const showProposteTimeline = true;

    const createTimelineBarFilterHandler = (field, addFilter) => (params) => {
        const [monthStr, yearStr] = params.split(' ');
        const month = parseInt(monthStr, 10) - 1;
        const year = parseInt(yearStr, 10);

        const start = new Date(year, month, 1);
        const end = new Date(year, month + 1, 0);

        addFilter(field, params);
    };

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Proposte')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <ProposteAnalisiKPISet dataProviderName={dataProviderName} filters={filterModel} />
                </Box>
            }

            {showProposteTimeline &&
                <Box className="report-itemgroup report-itemgroup-timeline" sx={{ marginTop: '10px', marginBottom: '30px' }}>
                    <Box className="report-item">
                        <Bar
                            title={t("Proposal per mese")}
                            dataProviderName="statisticsviews/proposalbymonth/timelined/views_opportunities_proposal/registered_at/month/null/_related_area_name"
                            filters={filterModel}
                            handleFilterChange={createTimelineBarFilterHandler('registered_at', addFilter)}
                            showTooltip={true}
                        />
                        <Bar
                            title={t("Proposal per settimana")}
                            dataProviderName="statisticsviews/proposalbyweek/timelined/views_opportunities_proposal/registered_at/week"
                            filters={filterModel}
                            handleFilterChange={createTimelineBarFilterHandler('registered_at', addFilter)}
                            height={200}
                        />
                    </Box>
                </Box>
            }
        </Box>
    )
}

export default ProposteTimeline;
